import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AsyncButton, SaveStates } from '@infl-ts/ui-advocate-components';
import { includesPermission, Permission, useAdminPermissions } from '@infl-ts/util-use-admin-permissions';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Typography } from '@mui/material';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useTranslation } from 'react-i18next';
import { useHidePublicResponse, useShowPublicResponse } from './mutations';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var HideResponseButton = function HideResponseButton(_ref) {
  var profile = _ref.profile,
      hiddenFromMembers = _ref.hiddenFromMembers,
      id = _ref.id;

  var _useHidePublicRespons = useHidePublicResponse(),
      _useHidePublicRespons2 = _slicedToArray(_useHidePublicRespons, 2),
      hideResponse = _useHidePublicRespons2[0],
      hideMutationStatus = _useHidePublicRespons2[1];

  var _useShowPublicRespons = useShowPublicResponse(),
      _useShowPublicRespons2 = _slicedToArray(_useShowPublicRespons, 2),
      showResponse = _useShowPublicRespons2[0],
      showMutationStatus = _useShowPublicRespons2[1];

  var hasMemberInteractionAccess = pipe(useAdminPermissions(profile), O.exists(includesPermission(Permission.map.MemberInteractionsAccess)));
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Error = SaveStates.Error;
  var hideMutationValue = useMutationMapper(hideMutationStatus, function (_ref2) {
    var hidePublicResponse = _ref2.hidePublicResponse;
    return hidePublicResponse.__typename === 'Error' ? E.left(hidePublicResponse) : E.right(hidePublicResponse);
  }, [Saving, Default, Error, Default]);
  var showMutationValue = useMutationMapper(showMutationStatus, function (_ref3) {
    var showPublicResponse = _ref3.showPublicResponse;
    return showPublicResponse.__typename === 'Error' ? E.left(showPublicResponse) : E.right(showPublicResponse);
  }, [Saving, Default, Error, Default]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (!hasMemberInteractionAccess) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AsyncButton, {
      variant: "text",
      sx: {
        color: function color(t) {
          return t.palette.text.secondary;
        },
        fontWeight: function fontWeight(t) {
          return t.typography.fontWeightBold;
        },
        px: 1,
        minWidth: 'auto'
      },
      size: "small",
      onClick: function onClick() {
        return hiddenFromMembers ? showResponse({
          variables: {
            id: id
          }
        }) : hideResponse({
          variables: {
            id: id
          }
        });
      },
      status: hiddenFromMembers ? showMutationValue : hideMutationValue,
      text: hiddenFromMembers ? ['Unhiding...', 'Hide', 'Unhide', 'Unhide'] : ['Hiding...', 'Unhide', 'Hide', 'Hide'],
      "data-element": "AsyncButton",
      "data-component": "HideResponseButton",
      "data-source-file": "hide-response-button.tsx"
    }), hiddenFromMembers && /*#__PURE__*/_jsx(Typography, {
      variant: "caption",
      sx: {
        alignSelf: 'center',
        lineHeight: 'inherit'
      },
      children: t("Members can't see this because it's hidden")
    })]
  });
};

export default HideResponseButton;